var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg13 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23.9988,
  height: 24,
  fill: "black"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 21.2693,
  y: 12.9961,
  width: 8.14286,
  height: 4.71429,
  transform: "rotate(90 21.2693 12.9961)",
  fill: "white",
  stroke: "white"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 21.156,
  y: 2.78516,
  width: 8.14286,
  height: 18.4286,
  transform: "rotate(90 21.156 2.78516)",
  fill: "white",
  stroke: "white"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 14.4131,
  y: 13.0703,
  width: 8.14286,
  height: 4.71429,
  transform: "rotate(90 14.4131 13.0703)",
  fill: "white",
  stroke: "white"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 7.55664,
  y: 13.1484,
  width: 8.14286,
  height: 4.71429,
  transform: "rotate(90 7.55664 13.1484)",
  fill: "white",
  stroke: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg13);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c4ef596c1874ee81fc7b2f484d81c602.svg";